import { render, staticRenderFns } from "./InfantClubPopUp.vue?vue&type=template&id=1fd1efc8"
import script from "./InfantClubPopUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfantClubPopUp.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports